import { RESTAURANT_INFO } from "../data/menu";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 text-white/60 py-8 pb-24 sm:pb-10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <p className="font-display text-xl uppercase tracking-tight text-white">
            Mariscos Popeye <span className="text-red-500">1985</span>
          </p>
          <p className="text-xs uppercase tracking-widest mt-1">
            Directo del mar a su paladar.
          </p>
        </div>
        <div className="text-xs uppercase tracking-widest">
          © {new Date().getFullYear()} {RESTAURANT_INFO.name}. Hecho con sazón
          en Chihuahua.
        </div>
      </div>
    </footer>
  );
};
